import { render, staticRenderFns } from "./LoadDetailSkeleton.vue?vue&type=template&id=1a5ddb9b&scoped=true"
import script from "./LoadDetailSkeleton.vue?vue&type=script&lang=js"
export * from "./LoadDetailSkeleton.vue?vue&type=script&lang=js"
import style0 from "./LoadDetailSkeleton.vue?vue&type=style&index=0&id=1a5ddb9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5ddb9b",
  null
  
)

export default component.exports